
export const setUserData = (user) => {
  if (!user) return new Error("no user data for set it ..!");
  localStorage.setItem("userData", JSON.stringify(user));
};

export const getUserData = () => {
  let userData = localStorage.getItem("userData");
  if (!userData) {
    return new Error("no user data for get it ..!");
  } else return JSON.parse( userData);
};

export const deleteUserData = () => {
  localStorage.removeItem("userData");
};

export const setUserDataProp = (prop, value) => {
  if (!prop && !value) return new Error("no prop name or value to set it ..!");
  let userData = JSON.parse(localStorage.get("userData"));
  userData[prop] = value;
  localStorage.setItem("userData", JSON.stringify(userData));
};

export const setToken = (token) => {
  if (!token) return new Error("no token value for set it ..!");
  localStorage.setItem("token", token);
};

export const getToken = () => {
  let userToken = localStorage.getItem("token");
  if (!userToken) {
    return new Error("no token value for get it ..!");
  } else return userToken;
};

export const setB2BTokens = (tokens) => {
  if(!tokens) return new Error("no token value for set it ..!");
  localStorage.setItem("b2bTokens", JSON.stringify(tokens))
}

export const getB2BTokens = () => {
  let b2bTokens = localStorage.getItem("b2bTokens")

  return JSON.parse(b2bTokens)
}

export const deleteToken = () => {
  localStorage.removeItem("token");
};

export const logoutHandler = () => {
  localStorage.clear();
};